import {
  isEnergyPitchFunnelSpecificVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const MILICAM01_IMAGES = {
  welcomeAgeBuckets: {
    eighteenToTwentyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_18_29.webp',
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_18_29@2x.webp',
      ],
    },
    thirtyToThirtyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_30_39.webp',
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_30_39@2x.webp',
      ],
    },
    fortyToFortyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_40_49.webp',
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyPlus: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_50_plus.webp',
        '/images/milicam01/realistic/welcome-age-buckets/welcome_age_buckets_option_50_plus@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/milicam01/realistic/social_proof_millions.webp',
        '/images/milicam01/realistic/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/milicam01/realistic/social-proof-millions/group.webp',
        '/images/milicam01/realistic/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/milicam01/realistic/experience.webp',
        '/images/milicam01/realistic/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/experience_pitch.webp',
        '/images/milicam01/realistic/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/milicam01/realistic/main-goal/main_goal_option_gain_muscle.webp',
        '/images/milicam01/realistic/main-goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/milicam01/realistic/main-goal/main_goal_option_improve_fitness.webp',
        '/images/milicam01/realistic/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/milicam01/realistic/main-goal/main_goal_option_lose_weight.webp',
        '/images/milicam01/realistic/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/struggle/struggle_option_back.webp',
        '/images/milicam01/realistic/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/struggle/struggle_option_knees.webp',
        '/images/milicam01/realistic/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/struggle/struggle_option_none.webp',
        '/images/milicam01/realistic/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/milicam01/realistic/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_knees.webp',
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_back.webp',
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_both.webp',
        '/images/milicam01/realistic/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extra: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/physical-build/physical_build_option_significantly_overweight.webp',
        '/images/milicam01/realistic/physical-build/physical_build_option_significantly_overweight@2x.webp',
      ],
    },
    plusSize: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/physical-build/physical_build_option_bigger.webp',
        '/images/milicam01/realistic/physical-build/physical_build_option_bigger@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/physical-build/physical_build_option_medium_build.webp',
        '/images/milicam01/realistic/physical-build/physical_build_option_medium_build@2x.webp',
      ],
    },
    skinnySlim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/physical-build/physical_build_option_slender.webp',
        '/images/milicam01/realistic/physical-build/physical_build_option_slender@2x.webp',
      ],
    },
  },
  bodyGoal: {
    bitLeaner: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/body-goal/body_goal_option_a_bit_leaner.webp',
        '/images/milicam01/realistic/body-goal/body_goal_option_a_bit_leaner@2x.webp',
      ],
    },
    athletic: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/body-goal/body_goal_option_athletic.webp',
        '/images/milicam01/realistic/body-goal/body_goal_option_athletic@2x.webp',
      ],
    },
    shredded: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/body-goal/body_goal_option_shredded.webp',
        '/images/milicam01/realistic/body-goal/body_goal_option_shredded@2x.webp',
      ],
    },
    extraBulky: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/milicam01/realistic/body-goal/body_goal_option_extra_bulky.webp',
        '/images/milicam01/realistic/body-goal/body_goal_option_extra_bulky@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/milicam01/realistic/problem-areas/problem_areas_option_belly.webp',
        '/images/milicam01/realistic/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    pecs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/milicam01/realistic/problem-areas/problem_areas_option_pecs.webp',
        '/images/milicam01/realistic/problem-areas/problem_areas_option_pecs@2x.webp',
      ],
    },
    arms: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/milicam01/realistic/problem-areas/problem_areas_option_arms.webp',
        '/images/milicam01/realistic/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
    thighs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/milicam01/realistic/problem-areas/problem_areas_option_legs.webp',
        '/images/milicam01/realistic/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/milicam01/realistic/how_often_exercise.webp',
        '/images/milicam01/realistic/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/milicam01/realistic/how_often_walks.webp',
        '/images/milicam01/realistic/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/milicam01/realistic/flexible.webp',
        '/images/milicam01/realistic/flexible@2x.webp',
      ],
    },
  },
  energyPitch: {
    person: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/energy-pitch/person.webp',
        '/images/milicam01/realistic/energy-pitch/person@2x.webp',
      ],
      prefetchCondition: isEnergyPitchFunnelSpecificVariant,
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/water_intake.webp',
        '/images/milicam01/realistic/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/milicam01/realistic/sleep_duration.webp',
        '/images/milicam01/realistic/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/milicam01/realistic/wellness-profile/wellness_profile_overweight.webp',
        '/images/milicam01/realistic/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/milicam01/realistic/wellness-profile/wellness_profile_bigger.webp',
        '/images/milicam01/realistic/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/milicam01/realistic/wellness-profile/wellness_profile_medium_build.webp',
        '/images/milicam01/realistic/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/milicam01/realistic/wellness-profile/wellness_profile_slender.webp',
        '/images/milicam01/realistic/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/milicam01/realistic/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
